import env from '../../env';

const CONTENTO_API_URL = `${env.CONTENTO_API}?ua=${env.USER_AGENT}`;

const continueWatchQuery = `
query ContinueWatchingQuery($history: [History!]!) {
    keepWatching(history: $history) {
        id
        name
        analyticsIdentifiers {
            listId
            listType
        }
        items {
            heading
            subHeading
            images {
                wide {
                    id
                    changed
                    description
                }
            }
            progressFraction
            item {
                __typename
                svtId
                urls {
                    svtplay
                }
                longDescription
                id
                oppetArkiv
                restrictions {
                    onlyAvailableInSweden
                }
                associatedContent(include: [productionPeriod, season]) {
                    name
                    items {
                        name
                    }
                }
                ... on Playable {
                    duration
                    validTo
                    live {
                        liveNow
                        start
                        plannedEnd
                    }
                    parent {
                        __typename
                        id
                    }
                }
                ... on ExtraMaterial {
                    validTo
                    durationFormatted
                    duration
                    name
                }
            }
        }
    }
}
`;

const fetchContinueWatchItems = (history) =>
    fetch(CONTENTO_API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({
            query: continueWatchQuery,
            variables: { history },
        }),
    }).then((result) => result.json());

export default fetchContinueWatchItems;
